import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import CongratulationsPageSell from "../../containers/CongratulationPageSell/CongratulationSellContainer";

export const congratulationsSellRoutes: RouteObject[] = [
    {
        title: "CongratulationsPageSell",
        path: "/agradecimiento/venta", 
        component: <CongratulationsPageSell />
    }
];